import { AppShell, Container } from "@mantine/core";
import { type PropsWithChildren } from "react";

import { useAuth } from "@/api/resources/auth/hooks";
import LayoutFooter from "@/components/Layout/LayoutFooter";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import { LAYOUT_HEADER_HEIGHT } from "@/configs/layout";

export const LayoutNavless = ({ children }: PropsWithChildren) => {
  const { isAuthenticated } = useAuth();
  return (
    <AppShell
      withBorder={false}
      header={{ height: LAYOUT_HEADER_HEIGHT }}
      footer={{
        height: "auto",
        offset: false,
      }}
      padding={{
        base: "xs",
        sm: "lg",
      }}
    >
      <AppShell.Header>
        <LayoutHeader />
      </AppShell.Header>

      <AppShell.Main>
        <Container size="lg">{children}</Container>
      </AppShell.Main>

      {!isAuthenticated && (
        <AppShell.Footer>
          <LayoutFooter />
        </AppShell.Footer>
      )}
    </AppShell>
  );
};

export default LayoutNavless;
